import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

interface DialogData {
  list: any;
  typeList: string;
}

@Component({
  selector: 'app-opendialog-show-listing',
  templateUrl: './opendialog-show-listing.component.html',
  styleUrls: ['./opendialog-show-listing.component.scss']
})
export class OpendialogShowListingComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<OpendialogShowListingComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit(): void { }

}
